import { useState, useEffect } from "react";
import axios from "axios";
import host from "../components/host";

function GscHome() {
  const [trimesters, setTrimesters] = useState([]);
  const [selectedTrim, setSelectedTrim] = useState(0);
  const [searchOp] = useState([
    { id: 1, value: "By Room" },
    { id: 2, value: "By Instructor" },
    { id: 3, value: "By Subject" },
  ]);
  const [searchBy, setSearchBy] = useState(0);
  const [inputSearch, setInputSearch] = useState("");

  useEffect(() => {
    loadTrimesters();
  }, []);

  // Search is intentionally triggered on input updates only.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    search();
  }, [inputSearch]);

  const loadTrimesters = () => {
    axios.get(`${host}loadTrimesters`).then((res) => {
      setTrimesters(res.data);
    });
  };

  const search = () => {
    axios
      .post(`${host}search`, {
        input: inputSearch,
        idsyc: selectedTrim,
        searchBy: searchBy,
      })
      .then((res) => {
        console.log(res.data);
      });
  };

  return (
    <div className="flex min-h-[100dvh] w-full flex-col bg-slate-100">
      <header className="sticky top-0 z-10 border-b border-slate-200/80 bg-white/85 px-4 py-4 shadow-sm backdrop-blur-md sm:px-6">
        <h1 className="text-lg font-bold tracking-tight text-slate-900 sm:text-xl">
          Class monitoring
        </h1>
        <p className="mt-0.5 text-sm text-slate-500">Search and filter class data</p>
      </header>

      <div className="flex flex-1 flex-col gap-4 p-4 sm:p-6">
        <div className="rounded-2xl border border-slate-200/80 bg-white p-4 shadow-sm sm:p-5">
          <div className="flex flex-col gap-3 sm:flex-row sm:flex-wrap sm:items-end">
            <div className="min-w-0 flex-1 sm:min-w-[12rem]">
              <label className="mb-1 block text-xs font-medium uppercase tracking-wide text-slate-500">
                Search
              </label>
              <input
                className="peaci-input"
                type="text"
                placeholder="Keyword or code…"
                value={inputSearch}
                onChange={(e) => setInputSearch(e.target.value)}
              />
            </div>
            <div className="w-full sm:w-auto sm:min-w-[11rem]">
              <label className="mb-1 block text-xs font-medium uppercase tracking-wide text-slate-500">
                Search by
              </label>
              <select
                className="peaci-select"
                value={searchBy}
                onChange={(e) => setSearchBy(e.target.value)}
              >
                <option value="0" hidden disabled>
                  Search by
                </option>
                {searchOp.map((val, key) => (
                  <option key={key} value={val.id}>
                    {val.value}
                  </option>
                ))}
              </select>
            </div>
            <div className="w-full sm:w-auto sm:min-w-[11rem]">
              <label className="mb-1 block text-xs font-medium uppercase tracking-wide text-slate-500">
                Trimester
              </label>
              <select
                className="peaci-select"
                value={selectedTrim}
                onChange={(e) => setSelectedTrim(e.target.value)}
              >
                <option value="0" disabled hidden>
                  Select trimester
                </option>
                {trimesters.map((val, key) => (
                  <option key={key} value={val.idsyc}>
                    {val.sy_name}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </div>

        <div className="flex min-h-[12rem] flex-1 flex-col rounded-2xl border border-slate-200/80 bg-white shadow-sm">
          <div className="flex flex-1 items-center justify-center px-4 py-12 text-center text-sm text-slate-500">
            <p className="max-w-md">
              Results will appear here when the search API returns data.
            </p>
          </div>
        </div>

        <footer className="mt-auto rounded-xl border border-slate-200 bg-slate-50 px-4 py-3 text-center text-xs text-slate-500">
          GSC · my.PEACI
        </footer>
      </div>
    </div>
  );
}

export default GscHome;
